var map = {
	"./activities/elections/election_post/da.yml": 381,
	"./activities/elections/election_post/en.yml": 382,
	"./activities/index/card/da.yml": 383,
	"./activities/index/card/description/da.yml": 384,
	"./activities/index/card/description/en.yml": 385,
	"./activities/index/card/en.yml": 386,
	"./activities/index/da.yml": 387,
	"./activities/index/en.yml": 388,
	"./activities/link_cards/index/da.yml": 389,
	"./activities/link_cards/index/en.yml": 390,
	"./activities/register_button/da.yml": 391,
	"./activities/register_button/en.yml": 392,
	"./activities/regret_unregister_button/da.yml": 393,
	"./activities/regret_unregister_button/en.yml": 394,
	"./activities/show/da.yml": 395,
	"./activities/show/en.yml": 396,
	"./activities/show/politics/da.yml": 397,
	"./activities/show/politics/en.yml": 398,
	"./admin/abilities/table/da.yml": 399,
	"./admin/abilities/table/en.yml": 400,
	"./admin/ability_group_abilities/lock_icon/da.yml": 401,
	"./admin/ability_group_abilities/lock_icon/en.yml": 402,
	"./admin/ability_groups/edit/da.yml": 403,
	"./admin/ability_groups/edit/en.yml": 404,
	"./admin/ability_groups/table/da.yml": 405,
	"./admin/ability_groups/table/en.yml": 406,
	"./admin/activities/activities_nav/da.yml": 407,
	"./admin/activities/activities_nav/en.yml": 408,
	"./admin/activities/billing/da.yml": 409,
	"./admin/activities/billing/en.yml": 410,
	"./admin/activities/children/da.yml": 411,
	"./admin/activities/children/en.yml": 412,
	"./admin/activities/create_card/expandable_content/da.yml": 413,
	"./admin/activities/create_card/expandable_content/en.yml": 414,
	"./admin/activities/create_card/surveys_card/da.yml": 415,
	"./admin/activities/create_card/surveys_card/en.yml": 416,
	"./admin/activities/edit/da.yml": 417,
	"./admin/activities/edit/en.yml": 418,
	"./admin/activities/index/da.yml": 419,
	"./admin/activities/index/en.yml": 420,
	"./admin/activities/live/agenda/item_types/election/election_post/da.yml": 421,
	"./admin/activities/live/agenda/item_types/election/election_post/en.yml": 422,
	"./admin/activities/live/agenda/item_types/election/election_post_card/da.yml": 423,
	"./admin/activities/live/agenda/item_types/election/election_post_card/en.yml": 424,
	"./admin/activities/live/agenda/item_types/election/election_post_contact_card/da.yml": 425,
	"./admin/activities/live/agenda/item_types/election/election_post_contact_card/en.yml": 426,
	"./admin/activities/live/agenda/item_types/election/index/da.yml": 427,
	"./admin/activities/live/agenda/item_types/election/index/en.yml": 428,
	"./admin/activities/live/agenda/item_types/proposal/proposal_card/da.yml": 429,
	"./admin/activities/live/agenda/item_types/proposal/proposal_card/en.yml": 430,
	"./admin/activities/live/agenda/item_types/speaker_list/actions_bar/next_speaker_button/da.yml": 431,
	"./admin/activities/live/agenda/item_types/speaker_list/actions_bar/next_speaker_button/en.yml": 432,
	"./admin/activities/live/agenda/item_types/speaker_list/da.yml": 433,
	"./admin/activities/live/agenda/item_types/speaker_list/en.yml": 434,
	"./admin/activities/live_nav/da.yml": 435,
	"./admin/activities/live_nav/en.yml": 436,
	"./admin/activities/nav/da.yml": 437,
	"./admin/activities/nav/en.yml": 438,
	"./admin/activities/participants/da.yml": 439,
	"./admin/activities/participants/en.yml": 440,
	"./admin/activities/participants/index/da.yml": 441,
	"./admin/activities/participants/index/en.yml": 442,
	"./admin/activities/politics/proposals/da.yml": 443,
	"./admin/activities/politics/proposals/en.yml": 444,
	"./admin/activities/surveys/da.yml": 445,
	"./admin/activities/surveys/en.yml": 446,
	"./admin/activities/table/da.yml": 447,
	"./admin/activities/table/en.yml": 448,
	"./admin/activity_groups/create_card/da.yml": 449,
	"./admin/activity_groups/create_card/en.yml": 450,
	"./admin/activity_participant_type_rules/create_card/da.yml": 451,
	"./admin/activity_participant_type_rules/create_card/en.yml": 452,
	"./admin/activity_participant_type_rules/table/da.yml": 453,
	"./admin/activity_participant_type_rules/table/en.yml": 454,
	"./admin/activity_participants/expandable_content/da.yml": 455,
	"./admin/activity_participants/expandable_content/en.yml": 456,
	"./admin/activity_participants/index/da.yml": 457,
	"./admin/activity_participants/index/en.yml": 458,
	"./admin/activity_participants/invite/da.yml": 459,
	"./admin/activity_participants/invite/en.yml": 460,
	"./admin/activity_participants/requested_unregister/da.yml": 461,
	"./admin/activity_participants/requested_unregister/en.yml": 462,
	"./admin/activity_participants/table/da.yml": 463,
	"./admin/activity_participants/table/en.yml": 464,
	"./admin/activity_surveys/edit/da.yml": 465,
	"./admin/activity_surveys/edit/en.yml": 466,
	"./admin/activity_surveys/table/da.yml": 467,
	"./admin/activity_surveys/table/en.yml": 468,
	"./admin/agenda_item_element_speakers/create_card/da.yml": 469,
	"./admin/agenda_item_element_speakers/create_card/en.yml": 470,
	"./admin/agenda_item_element_speakers/table/da.yml": 471,
	"./admin/agenda_item_element_speakers/table/en.yml": 472,
	"./admin/agenda_item_elements/create_card/da.yml": 473,
	"./admin/agenda_item_elements/create_card/en.yml": 474,
	"./admin/agenda_items/create_card/da.yml": 475,
	"./admin/agenda_items/create_card/en.yml": 476,
	"./admin/agendas/create_card/da.yml": 477,
	"./admin/agendas/create_card/en.yml": 478,
	"./admin/agendas/live_button/da.yml": 479,
	"./admin/agendas/live_button/en.yml": 480,
	"./admin/bank_accounts/bank_account_modal/da.yml": 481,
	"./admin/bank_accounts/da.yml": 482,
	"./admin/bank_accounts/en.yml": 483,
	"./admin/bank_accounts/table/da.yml": 484,
	"./admin/bank_accounts/table/en.yml": 485,
	"./admin/bundle_photo_product/create_card/da.yml": 486,
	"./admin/bundle_photo_product/create_card/en.yml": 487,
	"./admin/bundles/edit/da.yml": 488,
	"./admin/bundles/edit/en.yml": 489,
	"./admin/bundles/select/da.yml": 490,
	"./admin/bundles/select/en.yml": 491,
	"./admin/bundles/show/da.yml": 492,
	"./admin/bundles/show/en.yml": 493,
	"./admin/call_list_entities/table/da.yml": 494,
	"./admin/call_list_entities/table/en.yml": 495,
	"./admin/call_lists/call_mode/call_list_entity_carousel/da.yml": 496,
	"./admin/call_lists/call_mode/call_list_entity_carousel/en.yml": 497,
	"./admin/call_lists/call_mode/index/da.yml": 498,
	"./admin/call_lists/call_mode/index/en.yml": 499,
	"./admin/call_lists/edit/da.yml": 500,
	"./admin/call_lists/edit/en.yml": 501,
	"./admin/call_lists/index/da.yml": 502,
	"./admin/call_lists/index/en.yml": 503,
	"./admin/call_lists/show/call_list_carousel/index/da.yml": 504,
	"./admin/call_lists/show/call_list_carousel/index/en.yml": 505,
	"./admin/call_lists/show/table/da.yml": 506,
	"./admin/call_lists/show/table/en.yml": 507,
	"./admin/call_lists/table/da.yml": 508,
	"./admin/call_lists/table/en.yml": 509,
	"./admin/comments/da.yml": 510,
	"./admin/comments/en.yml": 511,
	"./admin/comments/expanded_content_partial/da.yml": 512,
	"./admin/comments/expanded_content_partial/en.yml": 513,
	"./admin/comments/index/da.yml": 514,
	"./admin/comments/index/en.yml": 515,
	"./admin/communication/bottom_bar/da.yml": 516,
	"./admin/communication/bottom_bar/en.yml": 517,
	"./admin/communication/index/da.yml": 518,
	"./admin/communication/index/en.yml": 519,
	"./admin/communication/templates/da.yml": 520,
	"./admin/communication/templates/en.yml": 521,
	"./admin/competition_surveys/edit/da.yml": 522,
	"./admin/competition_surveys/edit/en.yml": 523,
	"./admin/competition_surveys/surveys/da.yml": 524,
	"./admin/competition_surveys/surveys/en.yml": 525,
	"./admin/competitions/edit/da.yml": 526,
	"./admin/competitions/edit/en.yml": 527,
	"./admin/competitions/form/da.yml": 528,
	"./admin/competitions/form/en.yml": 529,
	"./admin/competitions/index/da.yml": 530,
	"./admin/competitions/index/en.yml": 531,
	"./admin/competitions/surveys/da.yml": 532,
	"./admin/competitions/surveys/en.yml": 533,
	"./admin/components/photo_session_csvs/table/da.yml": 534,
	"./admin/components/photo_session_csvs/table/en.yml": 535,
	"./admin/components/photos/index/bottom_bar/da.yml": 536,
	"./admin/components/photos/index/bottom_bar/en.yml": 537,
	"./admin/components/sheet_layout_boxes/form/da.yml": 538,
	"./admin/components/sheet_layout_boxes/form/en.yml": 539,
	"./admin/contact_associates/create_card/da.yml": 540,
	"./admin/contact_associates/create_card/en.yml": 541,
	"./admin/contact_group_contacts/create_modal/da.yml": 542,
	"./admin/contact_group_contacts/create_modal/en.yml": 543,
	"./admin/contact_relationships/edit/da.yml": 544,
	"./admin/contact_relationships/edit/en.yml": 545,
	"./admin/contacts/anonymize_button/da.yml": 546,
	"./admin/contacts/anonymize_button/en.yml": 547,
	"./admin/contacts/convert_organization_to_person_button/da.yml": 548,
	"./admin/contacts/convert_organization_to_person_button/en.yml": 549,
	"./admin/contacts/edit/billing_contact/da.yml": 550,
	"./admin/contacts/edit/billing_contact/en.yml": 551,
	"./admin/contacts/edit/da.yml": 552,
	"./admin/contacts/edit/email/da.yml": 553,
	"./admin/contacts/edit/email/en.yml": 554,
	"./admin/contacts/edit/en.yml": 555,
	"./admin/contacts/edit/historical_data_card/da.yml": 556,
	"./admin/contacts/edit/historical_data_card/en.yml": 557,
	"./admin/contacts/edit/organization_content/da.yml": 558,
	"./admin/contacts/edit/organization_content/en.yml": 559,
	"./admin/contacts/edit/relationships/da.yml": 560,
	"./admin/contacts/edit/relationships/en.yml": 561,
	"./admin/contacts/edit/school_content/da.yml": 562,
	"./admin/contacts/edit/school_content/en.yml": 563,
	"./admin/contacts/edit/student_council_content/da.yml": 564,
	"./admin/contacts/edit/student_council_content/en.yml": 565,
	"./admin/contacts/edit/supplier_content/da.yml": 566,
	"./admin/contacts/edit/supplier_content/en.yml": 567,
	"./admin/contacts/index/bottom_bar/add_to_activity/da.yml": 568,
	"./admin/contacts/index/bottom_bar/add_to_activity/en.yml": 569,
	"./admin/contacts/index/bottom_bar/da.yml": 570,
	"./admin/contacts/index/bottom_bar/en.yml": 571,
	"./admin/contacts/index/da.yml": 572,
	"./admin/contacts/index/en.yml": 573,
	"./admin/contacts/index/expandable_content/da.yml": 574,
	"./admin/contacts/index/expandable_content/en.yml": 575,
	"./admin/contacts/index/filter_content/da.yml": 576,
	"./admin/contacts/index/filter_content/en.yml": 577,
	"./admin/contacts/index/old_nemoa_filter/da.yml": 578,
	"./admin/contacts/index/old_nemoa_filter/en.yml": 579,
	"./admin/contacts/link/da.yml": 580,
	"./admin/contacts/link/en.yml": 581,
	"./admin/contacts/merge/da.yml": 582,
	"./admin/contacts/merge/en.yml": 583,
	"./admin/contacts/relations/da.yml": 584,
	"./admin/contacts/relations/en.yml": 585,
	"./admin/contacts/show/create_user_modal/da.yml": 586,
	"./admin/contacts/show/create_user_modal/en.yml": 587,
	"./admin/contacts/show/da.yml": 588,
	"./admin/contacts/show/economy_and_integrations/da.yml": 589,
	"./admin/contacts/show/economy_and_integrations/en.yml": 590,
	"./admin/contacts/show/en.yml": 591,
	"./admin/contacts/show/historical_data_card/da.yml": 592,
	"./admin/contacts/show/historical_data_card/en.yml": 593,
	"./admin/contacts/show/memberships/add_subscription_card/da.yml": 594,
	"./admin/contacts/show/memberships/add_subscription_card/en.yml": 595,
	"./admin/contacts/show/nav/da.yml": 596,
	"./admin/contacts/show/nav/en.yml": 597,
	"./admin/contacts/show/organization_further_information_card/da.yml": 598,
	"./admin/contacts/show/organization_further_information_card/en.yml": 599,
	"./admin/contacts/show/organization_general_information_card/da.yml": 600,
	"./admin/contacts/show/organization_general_information_card/en.yml": 601,
	"./admin/contacts/show/person/surveys_nav/da.yml": 602,
	"./admin/contacts/show/person/surveys_nav/en.yml": 603,
	"./admin/contacts/show/person/user_teams/da.yml": 604,
	"./admin/contacts/show/person/user_teams/en.yml": 605,
	"./admin/contacts/show/person_general_information_card/da.yml": 606,
	"./admin/contacts/show/person_general_information_card/en.yml": 607,
	"./admin/contacts/show/realtions/da.yml": 608,
	"./admin/contacts/show/realtions/en.yml": 609,
	"./admin/contacts/show/relations/da.yml": 610,
	"./admin/contacts/show/relations/en.yml": 611,
	"./admin/contacts/show/school_information_card/da.yml": 612,
	"./admin/contacts/show/school_information_card/en.yml": 613,
	"./admin/contacts/show/student_council_information_card/da.yml": 614,
	"./admin/contacts/show/student_council_information_card/en.yml": 615,
	"./admin/contacts/show/uni_c/da.yml": 616,
	"./admin/contacts/show/uni_c/en.yml": 617,
	"./admin/contacts/show/user/da.yml": 618,
	"./admin/contacts/show/user/en.yml": 619,
	"./admin/contacts/status_select/da.yml": 620,
	"./admin/contacts/status_select/en.yml": 621,
	"./admin/contacts/update_number_of_students_from_csv/da.yml": 622,
	"./admin/contacts/update_number_of_students_from_csv/en.yml": 623,
	"./admin/economy/account_dimensions/da.yml": 624,
	"./admin/economy/account_dimensions/en.yml": 625,
	"./admin/economy/accounts/da.yml": 626,
	"./admin/economy/accounts/en.yml": 627,
	"./admin/economy/accounts/index/da.yml": 628,
	"./admin/economy/accounts/index/en.yml": 629,
	"./admin/economy/dimensions/da.yml": 630,
	"./admin/economy/dimensions/en.yml": 631,
	"./admin/economy/dimensions/index/da.yml": 632,
	"./admin/economy/dimensions/index/en.yml": 633,
	"./admin/economy/dimensions/locked_dimensions/da.yml": 634,
	"./admin/economy/employees/da.yml": 635,
	"./admin/economy/employees/en.yml": 636,
	"./admin/economy/index/da.yml": 637,
	"./admin/economy/index/en.yml": 638,
	"./admin/economy/invoices/da.yml": 639,
	"./admin/economy/invoices/en.yml": 640,
	"./admin/economy/nav/da.yml": 641,
	"./admin/economy/nav/en.yml": 642,
	"./admin/economy/subscription_renewal_generations/choose_plan_modal/da.yml": 643,
	"./admin/economy/subscription_renewal_generations/choose_plan_modal/en.yml": 644,
	"./admin/economy/subscription_renewal_generations/da.yml": 645,
	"./admin/economy/subscription_renewal_generations/en.yml": 646,
	"./admin/election_posts/table/da.yml": 647,
	"./admin/election_posts/table/en.yml": 648,
	"./admin/element_feedback/da.yml": 649,
	"./admin/element_feedback/en.yml": 650,
	"./admin/elements/edit/da.yml": 651,
	"./admin/elements/edit/en.yml": 652,
	"./admin/elements/show/da.yml": 653,
	"./admin/elements/show/en.yml": 654,
	"./admin/elements/table/da.yml": 655,
	"./admin/elements/table/en.yml": 656,
	"./admin/emails/admin_confirm_button/da.yml": 657,
	"./admin/emails/admin_confirm_button/en.yml": 658,
	"./admin/employee_prices/create_card/da.yml": 659,
	"./admin/employee_prices/create_card/en.yml": 660,
	"./admin/employee_prices/table/da.yml": 661,
	"./admin/employee_prices/table/en.yml": 662,
	"./admin/finance_dimension_values/table/da.yml": 663,
	"./admin/finance_dimension_values/table/en.yml": 664,
	"./admin/highscore_class_steps/edit/da.yml": 665,
	"./admin/highscore_class_steps/edit/en.yml": 666,
	"./admin/highscore_class_steps/table/da.yml": 667,
	"./admin/highscore_class_steps/table/en.yml": 668,
	"./admin/highscore_communes/table/da.yml": 669,
	"./admin/highscore_communes/table/en.yml": 670,
	"./admin/highscore_competitions/table/da.yml": 671,
	"./admin/highscore_competitions/table/en.yml": 672,
	"./admin/highscore_generation_surveys/show/da.yml": 673,
	"./admin/highscore_generation_surveys/show/en.yml": 674,
	"./admin/highscore_generation_teams/table/da.yml": 675,
	"./admin/highscore_generation_teams/table/en.yml": 676,
	"./admin/highscore_generations/nav/da.yml": 677,
	"./admin/highscore_generations/nav/en.yml": 678,
	"./admin/highscore_generations/overall_highscore/da.yml": 679,
	"./admin/highscore_generations/overall_highscore/en.yml": 680,
	"./admin/highscore_generations/participants/da.yml": 681,
	"./admin/highscore_generations/participants/en.yml": 682,
	"./admin/highscore_generations/show/da.yml": 683,
	"./admin/highscore_generations/show/en.yml": 684,
	"./admin/highscore_regions/table/da.yml": 685,
	"./admin/highscore_regions/table/en.yml": 686,
	"./admin/highscores/communes/da.yml": 687,
	"./admin/highscores/communes/en.yml": 688,
	"./admin/highscores/competitions/da.yml": 689,
	"./admin/highscores/competitions/en.yml": 690,
	"./admin/highscores/edit/da.yml": 691,
	"./admin/highscores/edit/en.yml": 692,
	"./admin/highscores/excluded_users/da.yml": 693,
	"./admin/highscores/excluded_users/en.yml": 694,
	"./admin/highscores/index/da.yml": 695,
	"./admin/highscores/index/en.yml": 696,
	"./admin/highscores/nav/da.yml": 697,
	"./admin/highscores/nav/en.yml": 698,
	"./admin/highscores/organizations/da.yml": 699,
	"./admin/highscores/organizations/en.yml": 700,
	"./admin/highscores/regions/da.yml": 701,
	"./admin/highscores/regions/en.yml": 702,
	"./admin/highscores/show/da.yml": 703,
	"./admin/highscores/show/en.yml": 704,
	"./admin/invoice_lines/create_card/da.yml": 705,
	"./admin/invoice_lines/create_card/en.yml": 706,
	"./admin/invoice_lines/table/da.yml": 707,
	"./admin/invoice_lines/table/en.yml": 708,
	"./admin/invoices/bottom_bar/da.yml": 709,
	"./admin/invoices/bottom_bar/en.yml": 710,
	"./admin/invoices/create_card/da.yml": 711,
	"./admin/invoices/create_card/en.yml": 712,
	"./admin/invoices/edit/da.yml": 713,
	"./admin/invoices/edit/en.yml": 714,
	"./admin/invoices/expandable_content/da.yml": 715,
	"./admin/invoices/expandable_content/en.yml": 716,
	"./admin/invoices/link/da.yml": 717,
	"./admin/invoices/link/en.yml": 718,
	"./admin/invoices/show/da.yml": 719,
	"./admin/invoices/show/en.yml": 720,
	"./admin/invoices/table/da.yml": 721,
	"./admin/invoices/table/en.yml": 722,
	"./admin/layout/bottom_bar/pagination/da.yml": 723,
	"./admin/layout/bottom_bar/pagination/en.yml": 724,
	"./admin/layout/da.yml": 725,
	"./admin/layout/en.yml": 726,
	"./admin/layout/slide_menu/da.yml": 727,
	"./admin/layout/slide_menu/en.yml": 728,
	"./admin/layout/slide_menu/index/da.yml": 729,
	"./admin/layout/slide_menu/index/en.yml": 730,
	"./admin/layout/top_menu/extended_search/da.yml": 731,
	"./admin/layout/top_menu/extended_search/en.yml": 732,
	"./admin/layout/top_menu/extended_search/group/da.yml": 733,
	"./admin/layout/top_menu/extended_search/group/en.yml": 734,
	"./admin/layout/top_menu/extended_search/group/rule/attribute_select/chooser/da.yml": 735,
	"./admin/layout/top_menu/extended_search/group/rule/attribute_select/chooser/en.yml": 736,
	"./admin/layout/top_menu/extended_search/group/rule/attribute_select/da.yml": 737,
	"./admin/layout/top_menu/extended_search/group/rule/attribute_select/en.yml": 738,
	"./admin/layout/top_menu/extended_search/group/rule/da.yml": 739,
	"./admin/layout/top_menu/extended_search/group/rule/en.yml": 740,
	"./admin/layout/top_menu/search_bar/da.yml": 741,
	"./admin/layout/top_menu/search_bar/deleted_at_filter/da.yml": 742,
	"./admin/layout/top_menu/search_bar/deleted_at_filter/en.yml": 743,
	"./admin/layout/top_menu/search_bar/en.yml": 744,
	"./admin/layout/top_menu/user_menu_item/menu/da.yml": 745,
	"./admin/layout/top_menu/user_menu_item/menu/en.yml": 746,
	"./admin/layout_bottom_bar/pagination/da.yml": 747,
	"./admin/layout_bottom_bar/pagination/en.yml": 748,
	"./admin/logs/card/da.yml": 749,
	"./admin/logs/card/en.yml": 750,
	"./admin/logs/details/reimbursement/update/da.yml": 751,
	"./admin/logs/details/reimbursement/update/en.yml": 752,
	"./admin/logs/details/update/da.yml": 753,
	"./admin/logs/details/update/en.yml": 754,
	"./admin/logs/headers/create/da.yml": 755,
	"./admin/logs/headers/create/en.yml": 756,
	"./admin/logs/headers/update/da.yml": 757,
	"./admin/logs/headers/update/en.yml": 758,
	"./admin/logs/index/da.yml": 759,
	"./admin/logs/index/en.yml": 760,
	"./admin/logs/names/activity_participant/da.yml": 761,
	"./admin/logs/names/activity_participant/en.yml": 762,
	"./admin/logs/table/da.yml": 763,
	"./admin/logs/table/en.yml": 764,
	"./admin/messages/create_message_modal/da.yml": 765,
	"./admin/messages/create_message_modal/en.yml": 766,
	"./admin/messages/create_modal/da.yml": 767,
	"./admin/messages/create_modal/en.yml": 768,
	"./admin/messages/table/da.yml": 769,
	"./admin/messages/table/en.yml": 770,
	"./admin/navigations/index/da.yml": 771,
	"./admin/navigations/index/en.yml": 772,
	"./admin/navigations/my_location/da.yml": 773,
	"./admin/navigations/my_location/en.yml": 774,
	"./admin/navigations/show/da.yml": 775,
	"./admin/navigations/show/en.yml": 776,
	"./admin/order_lines/expandable_content/orderables/photo_sheet_product_order_line/da.yml": 777,
	"./admin/order_lines/expandable_content/orderables/photo_sheet_product_order_line/en.yml": 778,
	"./admin/order_lines/table/da.yml": 779,
	"./admin/order_lines/table/en.yml": 780,
	"./admin/orders/bottom_bar/da.yml": 781,
	"./admin/orders/bottom_bar/en.yml": 782,
	"./admin/orders/cancel_button/da.yml": 783,
	"./admin/orders/cancel_button/en.yml": 784,
	"./admin/orders/create_shipments_in_workplace_button/da.yml": 785,
	"./admin/orders/create_shipments_in_workplace_button/en.yml": 786,
	"./admin/orders/finish_process_button/da.yml": 787,
	"./admin/orders/finish_process_button/en.yml": 788,
	"./admin/orders/generate_file_button/da.yml": 789,
	"./admin/orders/generate_file_button/en.yml": 790,
	"./admin/orders/generate_file_for_orders_in_workplace_button/da.yml": 791,
	"./admin/orders/generate_file_for_orders_in_workplace_button/en.yml": 792,
	"./admin/orders/generate_packing_slips_for_orders_in_workplace_button/da.yml": 793,
	"./admin/orders/generate_packing_slips_for_orders_in_workplace_button/en.yml": 794,
	"./admin/orders/index/da.yml": 795,
	"./admin/orders/index/en.yml": 796,
	"./admin/orders/order_lines/da.yml": 797,
	"./admin/orders/order_lines/en.yml": 798,
	"./admin/orders/process_button/da.yml": 799,
	"./admin/orders/process_button/en.yml": 800,
	"./admin/orders/show/da.yml": 801,
	"./admin/orders/show/en.yml": 802,
	"./admin/orders/statistics_modal/da.yml": 803,
	"./admin/orders/statistics_modal/en.yml": 804,
	"./admin/orders/table/da.yml": 805,
	"./admin/orders/table/en.yml": 806,
	"./admin/organizations/edit/da.yml": 807,
	"./admin/organizations/edit/en.yml": 808,
	"./admin/organizations/index/da.yml": 809,
	"./admin/organizations/index/en.yml": 810,
	"./admin/organizations/show/da.yml": 811,
	"./admin/organizations/show/en.yml": 812,
	"./admin/people/table/da.yml": 813,
	"./admin/people/table/en.yml": 814,
	"./admin/person_roles/create_for_contacts_modal/da.yml": 815,
	"./admin/person_roles/create_for_contacts_modal/en.yml": 816,
	"./admin/photo_colors/create_card/da.yml": 817,
	"./admin/photo_colors/create_card/en.yml": 818,
	"./admin/photo_colors/select/da.yml": 819,
	"./admin/photo_colors/select/en.yml": 820,
	"./admin/photo_products/resource_select/da.yml": 821,
	"./admin/photo_products/resource_select/en.yml": 822,
	"./admin/photo_products/table/da.yml": 823,
	"./admin/photo_products/table/en.yml": 824,
	"./admin/photo_qualities/create_card/da.yml": 825,
	"./admin/photo_qualities/create_card/en.yml": 826,
	"./admin/photo_qualities/select/da.yml": 827,
	"./admin/photo_qualities/select/en.yml": 828,
	"./admin/photo_session_group_contacts/table/da.yml": 829,
	"./admin/photo_session_group_contacts/table/en.yml": 830,
	"./admin/photo_sessions/actions_bar/da.yml": 831,
	"./admin/photo_sessions/actions_bar/en.yml": 832,
	"./admin/photo_sessions/bottom_bar/da.yml": 833,
	"./admin/photo_sessions/bottom_bar/en.yml": 834,
	"./admin/photo_sessions/nav/da.yml": 835,
	"./admin/photo_sessions/nav/en.yml": 836,
	"./admin/photo_sessions/row/da.yml": 837,
	"./admin/photo_sessions/row/en.yml": 838,
	"./admin/photo_sessions/show/index/da.yml": 839,
	"./admin/photo_sessions/show/index/en.yml": 840,
	"./admin/photo_sessions/split_view/da.yml": 841,
	"./admin/photo_sessions/split_view/en.yml": 842,
	"./admin/photo_sessions/table/da.yml": 843,
	"./admin/photo_sessions/table/en.yml": 844,
	"./admin/photo_sessions/tree/da.yml": 845,
	"./admin/photo_sessions/tree/en.yml": 846,
	"./admin/photo_sessions/upload_csv_modal/index/da.yml": 847,
	"./admin/photo_sessions/upload_csv_modal/index/en.yml": 848,
	"./admin/photo_sheet_product_sheet_layouts/create_card/da.yml": 849,
	"./admin/photo_sheet_product_sheet_layouts/create_card/en.yml": 850,
	"./admin/photo_sheet_products/edit/da.yml": 851,
	"./admin/photo_sheet_products/edit/en.yml": 852,
	"./admin/photo_sheet_products/select/da.yml": 853,
	"./admin/photo_sheet_products/select/en.yml": 854,
	"./admin/photo_types/create_card/da.yml": 855,
	"./admin/photo_types/create_card/en.yml": 856,
	"./admin/photo_types/select/da.yml": 857,
	"./admin/photo_types/select/en.yml": 858,
	"./admin/photos/add_photo_type_to_photos_in_workplace_modal/da.yml": 859,
	"./admin/photos/add_photo_type_to_photos_in_workplace_modal/en.yml": 860,
	"./admin/photos/canvas/da.yml": 861,
	"./admin/photos/canvas/en.yml": 862,
	"./admin/photos/create_card/da.yml": 863,
	"./admin/photos/create_card/en.yml": 864,
	"./admin/photos/table/da.yml": 865,
	"./admin/photos/table/en.yml": 866,
	"./admin/photos/upload_card/da.yml": 867,
	"./admin/photos/upload_card/en.yml": 868,
	"./admin/plans/edit/da.yml": 869,
	"./admin/plans/edit/en.yml": 870,
	"./admin/plans/show/da.yml": 871,
	"./admin/plans/show/en.yml": 872,
	"./admin/plans/subscriptions/da.yml": 873,
	"./admin/plans/subscriptions/en.yml": 874,
	"./admin/plans/table/da.yml": 875,
	"./admin/plans/table/en.yml": 876,
	"./admin/products/select/da.yml": 877,
	"./admin/products/select/en.yml": 878,
	"./admin/products/show/da.yml": 879,
	"./admin/products/show/en.yml": 880,
	"./admin/reimbursement/table/da.yml": 881,
	"./admin/reimbursement/table/en.yml": 882,
	"./admin/reimbursement_attachments/expandable_content/da.yml": 883,
	"./admin/reimbursement_attachments/expandable_content/description/da.yml": 884,
	"./admin/reimbursement_attachments/expandable_content/description/en.yml": 885,
	"./admin/reimbursement_attachments/expandable_content/en.yml": 886,
	"./admin/reimbursement_attachments/table/da.yml": 887,
	"./admin/reimbursement_attachments/table/en.yml": 888,
	"./admin/reimbursements/attachments/da.yml": 889,
	"./admin/reimbursements/attachments/en.yml": 890,
	"./admin/reimbursements/bottom_bar/da.yml": 891,
	"./admin/reimbursements/bottom_bar/en.yml": 892,
	"./admin/reimbursements/expense/da.yml": 893,
	"./admin/reimbursements/expense/en.yml": 894,
	"./admin/reimbursements/expense_sum/index/da.yml": 895,
	"./admin/reimbursements/expense_sum/index/en.yml": 896,
	"./admin/reimbursements/index/da.yml": 897,
	"./admin/reimbursements/index/en.yml": 898,
	"./admin/reimbursements/nav/da.yml": 899,
	"./admin/reimbursements/nav/en.yml": 900,
	"./admin/reimbursements/process/da.yml": 901,
	"./admin/reimbursements/process/en.yml": 902,
	"./admin/reimbursements/time/da.yml": 903,
	"./admin/reimbursements/time/en.yml": 904,
	"./admin/reimbursements/travel/da.yml": 905,
	"./admin/reimbursements/travel/en.yml": 906,
	"./admin/reimbursements/travel_sum/index/da.yml": 907,
	"./admin/reimbursements/travel_sum/index/en.yml": 908,
	"./admin/required_metadata/card/da.yml": 909,
	"./admin/required_metadata/card/en.yml": 910,
	"./admin/role_abilities/edit/da.yml": 911,
	"./admin/role_abilities/edit/en.yml": 912,
	"./admin/role_abilities/lock_icon/da.yml": 913,
	"./admin/role_abilities/lock_icon/en.yml": 914,
	"./admin/role_ability_groups/lock_icon/da.yml": 915,
	"./admin/role_ability_groups/lock_icon/en.yml": 916,
	"./admin/roles/abilities/da.yml": 917,
	"./admin/roles/abilities/en.yml": 918,
	"./admin/roles/ability_groups/da.yml": 919,
	"./admin/roles/ability_groups/en.yml": 920,
	"./admin/roles/edit/da.yml": 921,
	"./admin/roles/edit/en.yml": 922,
	"./admin/roles/show/da.yml": 923,
	"./admin/roles/show/en.yml": 924,
	"./admin/routes/contact_relationships/edit/da.yml": 925,
	"./admin/routes/contact_relationships/edit/en.yml": 926,
	"./admin/routes/webshop/photo_products/da.yml": 927,
	"./admin/routes/webshop/photo_products/en.yml": 928,
	"./admin/routes/webshop/tenant_photo_products/da.yml": 929,
	"./admin/routes/webshop/tenant_photo_products/en.yml": 930,
	"./admin/school_classes/index/da.yml": 931,
	"./admin/school_classes/index/en.yml": 932,
	"./admin/school_classes/table/da.yml": 933,
	"./admin/school_classes/table/en.yml": 934,
	"./admin/school_years/index/da.yml": 935,
	"./admin/school_years/index/en.yml": 936,
	"./admin/sending_rules/create_card/da.yml": 937,
	"./admin/sending_rules/create_card/en.yml": 938,
	"./admin/sending_rules/table/da.yml": 939,
	"./admin/sending_rules/table/en.yml": 940,
	"./admin/sheet_layout_boxes/edit_modal/edit_box_icon/da.yml": 941,
	"./admin/sheet_layout_boxes/edit_modal/edit_box_icon/en.yml": 942,
	"./admin/sheet_layouts/create_card/da.yml": 943,
	"./admin/sheet_layouts/create_card/en.yml": 944,
	"./admin/sheet_layouts/select/da.yml": 945,
	"./admin/sheet_layouts/select/en.yml": 946,
	"./admin/sheet_layouts/show/da.yml": 947,
	"./admin/sheet_layouts/show/duplicate_box_icon/da.yml": 948,
	"./admin/sheet_layouts/show/duplicate_box_icon/en.yml": 949,
	"./admin/sheet_layouts/show/en.yml": 950,
	"./admin/sheet_layouts/show/remove_box_icon/da.yml": 951,
	"./admin/sheet_layouts/show/remove_box_icon/en.yml": 952,
	"./admin/sheet_layouts_boxes/form/edit_box_icon/da.yml": 953,
	"./admin/sheet_layouts_boxes/form/edit_box_icon/en.yml": 954,
	"./admin/sheet_sizes/create_card/da.yml": 955,
	"./admin/sheet_sizes/create_card/en.yml": 956,
	"./admin/sheet_sizes/select/da.yml": 957,
	"./admin/sheet_sizes/select/en.yml": 958,
	"./admin/show_box_attributes/form/da.yml": 959,
	"./admin/show_box_attributes/form/en.yml": 960,
	"./admin/show_boxes/form/da.yml": 961,
	"./admin/show_boxes/form/en.yml": 962,
	"./admin/show_boxes/partial/attribute/da.yml": 963,
	"./admin/show_boxes/partial/attribute/en.yml": 964,
	"./admin/show_boxes/partial/box/da.yml": 965,
	"./admin/show_boxes/partial/box/en.yml": 966,
	"./admin/show_boxes/partial/da.yml": 967,
	"./admin/show_boxes/partial/en.yml": 968,
	"./admin/steps/da.yml": 969,
	"./admin/steps/edit/da.yml": 970,
	"./admin/steps/edit/en.yml": 971,
	"./admin/steps/element/da.yml": 972,
	"./admin/steps/element/en.yml": 973,
	"./admin/steps/element_feedback/da.yml": 974,
	"./admin/steps/element_feedback/en.yml": 975,
	"./admin/steps/element_feedback_option/da.yml": 976,
	"./admin/steps/element_feedback_option/en.yml": 977,
	"./admin/steps/elements/da.yml": 978,
	"./admin/steps/elements/en.yml": 979,
	"./admin/steps/en.yml": 980,
	"./admin/steps/show/da.yml": 981,
	"./admin/steps/show/en.yml": 982,
	"./admin/steps/table/da.yml": 983,
	"./admin/steps/table/en.yml": 984,
	"./admin/student_council_memberships/edit/da.yml": 985,
	"./admin/student_council_memberships/edit/en.yml": 986,
	"./admin/subjects/select/da.yml": 987,
	"./admin/subjects/select/en.yml": 988,
	"./admin/subscription_periods/table/da.yml": 989,
	"./admin/subscription_periods/table/en.yml": 990,
	"./admin/subscription_renewal_generations/show/da.yml": 991,
	"./admin/subscription_renewal_generations/show/en.yml": 992,
	"./admin/subscription_renewal_generations/table/da.yml": 993,
	"./admin/subscription_renewal_generations/table/en.yml": 994,
	"./admin/subscriptions/show/da.yml": 995,
	"./admin/subscriptions/show/en.yml": 996,
	"./admin/subscriptions/table/da.yml": 997,
	"./admin/subscriptions/table/en.yml": 998,
	"./admin/supplier_supported_photo_qualities/create_card/da.yml": 999,
	"./admin/supplier_supported_photo_qualities/create_card/en.yml": 1000,
	"./admin/supplier_supported_sheets/create_card/da.yml": 1001,
	"./admin/supplier_supported_sheets/create_card/en.yml": 1002,
	"./admin/suppliers/select/da.yml": 1003,
	"./admin/suppliers/select/en.yml": 1004,
	"./admin/survey_judges/row/da.yml": 1005,
	"./admin/survey_judges/row/en.yml": 1006,
	"./admin/surveys/activation_button/da.yml": 1007,
	"./admin/surveys/activation_button/en.yml": 1008,
	"./admin/surveys/edit/da.yml": 1009,
	"./admin/surveys/edit/en.yml": 1010,
	"./admin/surveys/index/da.yml": 1011,
	"./admin/surveys/index/en.yml": 1012,
	"./admin/surveys/nav/da.yml": 1013,
	"./admin/surveys/nav/en.yml": 1014,
	"./admin/surveys/show/da.yml": 1015,
	"./admin/surveys/show/en.yml": 1016,
	"./admin/surveys/survey_details/da.yml": 1017,
	"./admin/surveys/survey_details/en.yml": 1018,
	"./admin/surveys/survey_steps/da.yml": 1019,
	"./admin/surveys/survey_steps/en.yml": 1020,
	"./admin/surveys/table/da.yml": 1021,
	"./admin/surveys/table/en.yml": 1022,
	"./admin/taggings/taggable/da.yml": 1023,
	"./admin/taggings/taggable/en.yml": 1024,
	"./admin/taggings/taggable/form/da.yml": 1025,
	"./admin/taggings/taggable/form/en.yml": 1026,
	"./admin/tags/workplace_merge_button/da.yml": 1027,
	"./admin/tags/workplace_merge_button/en.yml": 1028,
	"./admin/team_surveys/bottom_bar/da.yml": 1029,
	"./admin/team_surveys/bottom_bar/en.yml": 1030,
	"./admin/team_surveys/index/da.yml": 1031,
	"./admin/team_surveys/index/en.yml": 1032,
	"./admin/team_surveys/show/da.yml": 1033,
	"./admin/team_surveys/show/en.yml": 1034,
	"./admin/team_surveys/show/user_step/da.yml": 1035,
	"./admin/team_surveys/show/user_step/en.yml": 1036,
	"./admin/team_surveys/table/da.yml": 1037,
	"./admin/team_surveys/table/en.yml": 1038,
	"./admin/team_users/edit/da.yml": 1039,
	"./admin/team_users/edit/en.yml": 1040,
	"./admin/team_users/show/da.yml": 1041,
	"./admin/team_users/show/en.yml": 1042,
	"./admin/teams/edit/da.yml": 1043,
	"./admin/teams/edit/en.yml": 1044,
	"./admin/teams/index/da.yml": 1045,
	"./admin/teams/index/en.yml": 1046,
	"./admin/teams/show/da.yml": 1047,
	"./admin/teams/show/en.yml": 1048,
	"./admin/templates/create_card/da.yml": 1049,
	"./admin/templates/create_card/en.yml": 1050,
	"./admin/tenant_domains/row/da.yml": 1051,
	"./admin/tenant_domains/row/en.yml": 1052,
	"./admin/tenant_domains/select/da.yml": 1053,
	"./admin/tenant_domains/select/en.yml": 1054,
	"./admin/tenant_photo_products/create_card/da.yml": 1055,
	"./admin/tenant_photo_products/create_card/en.yml": 1056,
	"./admin/tenant_photo_products/visible_in_shop/da.yml": 1057,
	"./admin/tenant_photo_products/visible_in_shop/en.yml": 1058,
	"./admin/tenants/create_card/da.yml": 1059,
	"./admin/tenants/create_card/en.yml": 1060,
	"./admin/tenants/integrations/bambora/da.yml": 1061,
	"./admin/tenants/integrations/bambora/en.yml": 1062,
	"./admin/tenants/integrations/inventio/da.yml": 1063,
	"./admin/tenants/integrations/inventio/en.yml": 1064,
	"./admin/tenants/integrations/nav/da.yml": 1065,
	"./admin/tenants/integrations/nav/en.yml": 1066,
	"./admin/tenants/integrations/shipmondo/da.yml": 1067,
	"./admin/tenants/integrations/shipmondo/en.yml": 1068,
	"./admin/tenants/nav/da.yml": 1069,
	"./admin/tenants/nav/en.yml": 1070,
	"./admin/tenants/setup/da.yml": 1071,
	"./admin/tenants/setup/en.yml": 1072,
	"./admin/toggle_eye_button/da.yml": 1073,
	"./admin/toggle_eye_button/en.yml": 1074,
	"./admin/user_elements/answer/da.yml": 1075,
	"./admin/user_elements/answer/en.yml": 1076,
	"./admin/user_elements/edit/da.yml": 1077,
	"./admin/user_elements/edit/en.yml": 1078,
	"./admin/users/edit/da.yml": 1079,
	"./admin/users/edit/en.yml": 1080,
	"./admin/users/index/da.yml": 1081,
	"./admin/users/index/en.yml": 1082,
	"./admin/users/passwords/edit/da.yml": 1083,
	"./admin/users/passwords/edit/en.yml": 1084,
	"./admin/users/passwords/new/da.yml": 1085,
	"./admin/users/passwords/new/en.yml": 1086,
	"./admin/users/show/da.yml": 1087,
	"./admin/users/show/en.yml": 1088,
	"./admin/workplaces/bottom_bar/add_relationship_to_workplace_modal/da.yml": 1089,
	"./admin/workplaces/bottom_bar/add_relationship_to_workplace_modal/en.yml": 1090,
	"./admin/workplaces/bottom_bar/da.yml": 1091,
	"./admin/workplaces/bottom_bar/en.yml": 1092,
	"./admin/workplaces/bottom_bar/index/da.yml": 1093,
	"./admin/workplaces/bottom_bar/index/en.yml": 1094,
	"./agenda_item_elements/edit/audio/da.yml": 1095,
	"./agenda_item_elements/edit/audio/en.yml": 1096,
	"./agenda_item_elements/edit/document/da.yml": 1097,
	"./agenda_item_elements/edit/document/en.yml": 1098,
	"./agenda_item_elements/edit/image/da.yml": 1099,
	"./agenda_item_elements/edit/image/en.yml": 1100,
	"./agendas/actions_bar/da.yml": 1101,
	"./agendas/actions_bar/en.yml": 1102,
	"./agendas/live/da.yml": 1103,
	"./agendas/live/en.yml": 1104,
	"./bank_accounts/account_type_select/da.yml": 1105,
	"./bank_accounts/account_type_select/en.yml": 1106,
	"./block_ui/da.yml": 1107,
	"./block_ui/en.yml": 1108,
	"./buttons/table_expand/da.yml": 1109,
	"./buttons/table_expand/en.yml": 1110,
	"./classSteps/select/da.yml": 1111,
	"./classSteps/select/en.yml": 1112,
	"./competitions/choose_survey/da.yml": 1113,
	"./competitions/choose_survey/en.yml": 1114,
	"./competitions/choose_team/da.yml": 1115,
	"./competitions/choose_team/en.yml": 1116,
	"./competitions/choose_team_type/da.yml": 1117,
	"./competitions/choose_team_type/en.yml": 1118,
	"./competitions/index/da.yml": 1119,
	"./competitions/index/en.yml": 1120,
	"./competitions/show/da.yml": 1121,
	"./competitions/show/en.yml": 1122,
	"./competitions_choose_team/da.yml": 1123,
	"./competitions_choose_team/en.yml": 1124,
	"./components/responsive_nav/da.yml": 1125,
	"./components/responsive_nav/en.yml": 1126,
	"./confirm_dialog/da.yml": 1127,
	"./confirm_dialog/en.yml": 1128,
	"./contact_merge_requests/confirm_merge_request/da.yml": 1129,
	"./contact_merge_requests/confirm_merge_request/en.yml": 1130,
	"./contact_merge_requests/merge_request/da.yml": 1131,
	"./contact_merge_requests/merge_request/en.yml": 1132,
	"./contacts/select/da.yml": 1133,
	"./contacts/select/en.yml": 1134,
	"./election/school_elections/new/da.yml": 1135,
	"./election/school_elections/new/en.yml": 1136,
	"./element_types/da.yml": 1137,
	"./element_types/en.yml": 1138,
	"./feedback_assignments/show/da.yml": 1139,
	"./feedback_assignments/show/en.yml": 1140,
	"./feedback_steps/da.yml": 1141,
	"./feedback_steps/dropdown/da.yml": 1142,
	"./feedback_steps/dropdown/en.yml": 1143,
	"./feedback_steps/edit/da.yml": 1144,
	"./feedback_steps/edit/en.yml": 1145,
	"./feedback_steps/en.yml": 1146,
	"./flash_message/da.yml": 1147,
	"./flash_message/en.yml": 1148,
	"./forms/attachment_input/da.yml": 1149,
	"./forms/attachment_input/en.yml": 1150,
	"./forms/image_input/da.yml": 1151,
	"./forms/image_input/en.yml": 1152,
	"./global/da.yml": 1153,
	"./global/en.yml": 1154,
	"./jobler/job_status/da.yml": 1155,
	"./jobler/job_status/en.yml": 1156,
	"./layout/da.yml": 1157,
	"./layout/en.yml": 1158,
	"./layout/no_access/da.yml": 1159,
	"./layout/no_access/en.yml": 1160,
	"./layout/not_found/da.yml": 1161,
	"./layout/not_found/en.yml": 1162,
	"./layout/require_two_factor_authentication_proxy/da.yml": 1163,
	"./layout/require_two_factor_authentication_proxy/en.yml": 1164,
	"./layout/top_menu/user_meun_item/menu/da.yml": 1165,
	"./layout/top_menu/user_meun_item/menu/en.yml": 1166,
	"./layout/top_nav/da.yml": 1167,
	"./layout/top_nav/en.yml": 1168,
	"./layout/top_nav/notifications_modal/da.yml": 1169,
	"./layout/top_nav/notifications_modal/en.yml": 1170,
	"./live_streaming_feeds/broadcaster/index/da.yml": 1171,
	"./live_streaming_feeds/broadcaster/index/en.yml": 1172,
	"./live_streaming_feeds/broadcaster/settings/da.yml": 1173,
	"./live_streaming_feeds/broadcaster/settings/en.yml": 1174,
	"./live_streaming_feeds/viewer/da.yml": 1175,
	"./live_streaming_feeds/viewer/en.yml": 1176,
	"./merfoto/albums/index/da.yml": 1177,
	"./merfoto/albums/index/en.yml": 1178,
	"./merfoto/basket/basket_item_card/index/da.yml": 1179,
	"./merfoto/basket/basket_item_card/index/en.yml": 1180,
	"./merfoto/basket/da.yml": 1181,
	"./merfoto/basket/destroy_order_line_button/da.yml": 1182,
	"./merfoto/basket/destroy_order_line_button/en.yml": 1183,
	"./merfoto/basket/en.yml": 1184,
	"./merfoto/basket/quantity/da.yml": 1185,
	"./merfoto/basket/quantity/en.yml": 1186,
	"./merfoto/basket/unique_photos_label/da.yml": 1187,
	"./merfoto/basket/unique_photos_label/en.yml": 1188,
	"./merfoto/checkout/completed/da.yml": 1189,
	"./merfoto/checkout/completed/en.yml": 1190,
	"./merfoto/checkout/confirm/da.yml": 1191,
	"./merfoto/checkout/confirm/en.yml": 1192,
	"./merfoto/checkout/customer_information/da.yml": 1193,
	"./merfoto/checkout/customer_information/en.yml": 1194,
	"./merfoto/checkout/delivery/da.yml": 1195,
	"./merfoto/checkout/delivery/en.yml": 1196,
	"./merfoto/checkout/navbar/da.yml": 1197,
	"./merfoto/checkout/navbar/en.yml": 1198,
	"./merfoto/checkout/payment/da.yml": 1199,
	"./merfoto/checkout/payment/en.yml": 1200,
	"./merfoto/components/order_lines/edit/resources/bundle/da.yml": 1201,
	"./merfoto/components/order_lines/edit/resources/bundle/en.yml": 1202,
	"./merfoto/components/sheet-layouts/presentation/da.yml": 1203,
	"./merfoto/components/sheet-layouts/presentation/en.yml": 1204,
	"./merfoto/downloads/da.yml": 1205,
	"./merfoto/downloads/en.yml": 1206,
	"./merfoto/layout/footer/da.yml": 1207,
	"./merfoto/layout/footer/en.yml": 1208,
	"./merfoto/layout/footer/index/da.yml": 1209,
	"./merfoto/layout/footer/index/en.yml": 1210,
	"./merfoto/layout/index/da.yml": 1211,
	"./merfoto/layout/index/en.yml": 1212,
	"./merfoto/layout/top_bar/index/da.yml": 1213,
	"./merfoto/layout/top_bar/index/en.yml": 1214,
	"./merfoto/layout/top_bar/signed_in_user_button/menu_modal/da.yml": 1215,
	"./merfoto/layout/top_bar/signed_in_user_button/menu_modal/en.yml": 1216,
	"./merfoto/layout/topbar/index/da.yml": 1217,
	"./merfoto/layout/topbar/index/en.yml": 1218,
	"./merfoto/order_deliveries/delivery_methods/digital_download/options/da.yml": 1219,
	"./merfoto/order_deliveries/delivery_methods/digital_download/options/en.yml": 1220,
	"./merfoto/order_deliveries/delivery_methods/pick_up/index/da.yml": 1221,
	"./merfoto/order_deliveries/delivery_methods/pick_up/index/en.yml": 1222,
	"./merfoto/order_deliveries/delivery_methods/shipmondo/index/da.yml": 1223,
	"./merfoto/order_deliveries/delivery_methods/shipmondo/index/en.yml": 1224,
	"./merfoto/order_lines/edit/submit_image_button/da.yml": 1225,
	"./merfoto/order_lines/edit/submit_image_button/en.yml": 1226,
	"./merfoto/orders/da.yml": 1227,
	"./merfoto/orders/en.yml": 1228,
	"./merfoto/orders/table/da.yml": 1229,
	"./merfoto/orders/table/en.yml": 1230,
	"./merfoto/orders/total_with_delivery/da.yml": 1231,
	"./merfoto/orders/total_with_delivery/en.yml": 1232,
	"./merfoto/photo_session_group_contact_tokens/create_from_token_card/da.yml": 1233,
	"./merfoto/photo_session_group_contact_tokens/create_from_token_card/en.yml": 1234,
	"./merfoto/photo_session_group_contact_tokens/create_from_token_form/da.yml": 1235,
	"./merfoto/photo_session_group_contact_tokens/create_from_token_form/en.yml": 1236,
	"./merfoto/photo_session_group_contacts/select_album/da.yml": 1237,
	"./merfoto/photo_session_group_contacts/select_album/en.yml": 1238,
	"./merfoto/photo_session_groups/card/index/da.yml": 1239,
	"./merfoto/photo_session_groups/card/index/en.yml": 1240,
	"./merfoto/photo_session_groups/card/photo_card/da.yml": 1241,
	"./merfoto/photo_session_groups/card/photo_card/en.yml": 1242,
	"./merfoto/photo_sheet_product_order_lines/edit/da.yml": 1243,
	"./merfoto/photo_sheet_product_order_lines/edit/en.yml": 1244,
	"./merfoto/routes/albums/da.yml": 1245,
	"./merfoto/routes/albums/en.yml": 1246,
	"./merfoto/routes/welcome/da.yml": 1247,
	"./merfoto/routes/welcome/en.yml": 1248,
	"./merfoto/tenant_photo_products/add_to_basket_button/da.yml": 1249,
	"./merfoto/tenant_photo_products/add_to_basket_button/en.yml": 1250,
	"./merfoto/tenant_photo_products_with_photos/card/index/da.yml": 1251,
	"./merfoto/tenant_photo_products_with_photos/card/index/en.yml": 1252,
	"./merfoto/tenant_photo_products_with_photos/index/da.yml": 1253,
	"./merfoto/tenant_photo_products_with_photos/index/en.yml": 1254,
	"./merfoto/token/da.yml": 1255,
	"./merfoto/token/en.yml": 1256,
	"./merfoto/users/passwords/new/da.yml": 1257,
	"./merfoto/users/passwords/new/en.yml": 1258,
	"./merfoto/welcome/da.yml": 1259,
	"./merfoto/welcome/en.yml": 1260,
	"./merfoto/welcome_top_container/index/da.yml": 1261,
	"./merfoto/welcome_top_container/index/en.yml": 1262,
	"./models_table/add_column_button/da.yml": 1263,
	"./models_table/add_column_button/en.yml": 1264,
	"./models_table/columns_drop_down/da.yml": 1265,
	"./models_table/columns_drop_down/en.yml": 1266,
	"./navigations/index/da.yml": 1267,
	"./navigations/index/en.yml": 1268,
	"./navigations/show/da.yml": 1269,
	"./navigations/show/en.yml": 1270,
	"./nemoa/activities/elections/election/da.yml": 1271,
	"./nemoa/activities/elections/election/en.yml": 1272,
	"./nemoa/activities/index/card/participant_state_overlay/index/da.yml": 1273,
	"./nemoa/activities/index/card/participant_state_overlay/index/en.yml": 1274,
	"./nemoa/activities/mine/index/da.yml": 1275,
	"./nemoa/activities/mine/index/en.yml": 1276,
	"./nemoa/activities/nav/index/da.yml": 1277,
	"./nemoa/activities/nav/index/en.yml": 1278,
	"./nemoa/activities/required_metadata_proxy_with_surveys/da.yml": 1279,
	"./nemoa/activities/required_metadata_proxy_with_surveys/en.yml": 1280,
	"./nemoa/activities/show/elections/da.yml": 1281,
	"./nemoa/activities/show/elections/en.yml": 1282,
	"./nemoa/activities/show/elections/index/da.yml": 1283,
	"./nemoa/activities/show/elections/index/en.yml": 1284,
	"./nemoa/activities/show/index/da.yml": 1285,
	"./nemoa/activities/show/index/en.yml": 1286,
	"./nemoa/activities/show/live/da.yml": 1287,
	"./nemoa/activities/show/live/en.yml": 1288,
	"./nemoa/activities/show/nav/da.yml": 1289,
	"./nemoa/activities/show/nav/en.yml": 1290,
	"./nemoa/activities/show/politics/da.yml": 1291,
	"./nemoa/activities/show/politics/en.yml": 1292,
	"./nemoa/components/user_steps/element_types/question_sentence/da.yml": 1293,
	"./nemoa/components/user_steps/element_types/question_sentence/en.yml": 1294,
	"./nemoa/layout/slide_menu/index/da.yml": 1295,
	"./nemoa/layout/slide_menu/index/en.yml": 1296,
	"./nemoa/layout/top_menu/index/da.yml": 1297,
	"./nemoa/layout/top_menu/index/en.yml": 1298,
	"./nemoa/layout/top_menu/user_menu_item/index/da.yml": 1299,
	"./nemoa/layout/top_menu/user_menu_item/index/en.yml": 1300,
	"./nemoa/required_metadata/required_metadata_proxy/da.yml": 1301,
	"./nemoa/required_metadata/required_metadata_proxy/en.yml": 1302,
	"./nemoa/user_steps/edit/da.yml": 1303,
	"./nemoa/user_steps/edit/en.yml": 1304,
	"./nemoa/users/edit/form/index/da.yml": 1305,
	"./nemoa/users/edit/form/index/en.yml": 1306,
	"./nemoa/users/passwords/new/da.yml": 1307,
	"./nemoa/users/passwords/new/en.yml": 1308,
	"./nemoa_select/da.yml": 1309,
	"./nemoa_select/en.yml": 1310,
	"./notifications/types/team_application_accepted/da.yml": 1311,
	"./notifications/types/team_application_accepted/en.yml": 1312,
	"./notifications/types/team_application_declined/da.yml": 1313,
	"./notifications/types/team_application_declined/en.yml": 1314,
	"./notifications/types/team_survey_started/da.yml": 1315,
	"./notifications/types/team_survey_started/en.yml": 1316,
	"./organizations/select/da.yml": 1317,
	"./organizations/select/en.yml": 1318,
	"./preview/da.yml": 1319,
	"./preview/en.yml": 1320,
	"./proposal_types/presenter_card/da.yml": 1321,
	"./proposal_types/presenter_card/en.yml": 1322,
	"./registrations/form/da.yml": 1323,
	"./registrations/form/en.yml": 1324,
	"./reimbursements/attachments/create_card/da.yml": 1325,
	"./reimbursements/attachments/create_card/en.yml": 1326,
	"./reimbursements/create_card/da.yml": 1327,
	"./reimbursements/create_card/en.yml": 1328,
	"./reimbursements/create_card/extended_form/save_and_request_approval_button/da.yml": 1329,
	"./reimbursements/create_card/extended_form/save_and_request_approval_button/en.yml": 1330,
	"./reimbursements/create_card/extended_form/save_button/da.yml": 1331,
	"./reimbursements/create_card/extended_form/save_button/en.yml": 1332,
	"./reimbursements/create_card/index/da.yml": 1333,
	"./reimbursements/create_card/index/en.yml": 1334,
	"./reimbursements/documents/da.yml": 1335,
	"./reimbursements/documents/en.yml": 1336,
	"./reimbursements/documents_button/carousel/da.yml": 1337,
	"./reimbursements/documents_button/carousel/en.yml": 1338,
	"./reimbursements/expenses/index/da.yml": 1339,
	"./reimbursements/expenses/index/en.yml": 1340,
	"./reimbursements/index/da.yml": 1341,
	"./reimbursements/index/en.yml": 1342,
	"./reimbursements/index/time_sum/da.yml": 1343,
	"./reimbursements/index/time_sum/en.yml": 1344,
	"./reimbursements/table/da.yml": 1345,
	"./reimbursements/table/en.yml": 1346,
	"./reimbursements/time/da.yml": 1347,
	"./reimbursements/time/en.yml": 1348,
	"./reimbursements/travel/index/da.yml": 1349,
	"./reimbursements/travel/index/en.yml": 1350,
	"./roles/select/da.yml": 1351,
	"./roles/select/en.yml": 1352,
	"./save_modes/da.yml": 1353,
	"./save_modes/en.yml": 1354,
	"./school_classes/select/da.yml": 1355,
	"./school_classes/select/en.yml": 1356,
	"./sessions/new/da.yml": 1357,
	"./sessions/new/en.yml": 1358,
	"./sessions/new/index/da.yml": 1359,
	"./sessions/new/index/en.yml": 1360,
	"./sessions/new/one_time_password_prompt/da.yml": 1361,
	"./sessions/new/one_time_password_prompt/en.yml": 1362,
	"./sessions/new/uni_login_image_button/da.yml": 1363,
	"./sessions/new/uni_login_image_button/en.yml": 1364,
	"./shared/create_card/da.yml": 1365,
	"./shared/create_card/en.yml": 1366,
	"./shared/da.yml": 1367,
	"./shared/en.yml": 1368,
	"./shared/preview/da.yml": 1369,
	"./shared/preview/en.yml": 1370,
	"./shared/preview/index/da.yml": 1371,
	"./shared/preview/index/en.yml": 1372,
	"./shared/state_selector/da.yml": 1373,
	"./shared/state_selector/en.yml": 1374,
	"./shared/table/index/da.yml": 1375,
	"./shared/table/index/en.yml": 1376,
	"./shared/table/row/da.yml": 1377,
	"./shared/table/row/en.yml": 1378,
	"./shared/tree/index/da.yml": 1379,
	"./shared/tree/index/en.yml": 1380,
	"./shared/tree/node/da.yml": 1381,
	"./shared/tree/node/en.yml": 1382,
	"./sheet_layouts/presentation/index/da.yml": 1383,
	"./sheet_layouts/presentation/index/en.yml": 1384,
	"./steps/da.yml": 1385,
	"./steps/en.yml": 1386,
	"./surveys/list_partial/da.yml": 1387,
	"./surveys/list_partial/en.yml": 1388,
	"./surveys/show/da.yml": 1389,
	"./surveys/show/en.yml": 1390,
	"./team_surveys/complete/da.yml": 1391,
	"./team_surveys/complete/en.yml": 1392,
	"./team_surveys/edit/da.yml": 1393,
	"./team_surveys/edit/en.yml": 1394,
	"./team_surveys/feedback_states/da.yml": 1395,
	"./team_surveys/feedback_states/en.yml": 1396,
	"./team_surveys/time_used/da.yml": 1397,
	"./team_surveys/time_used/en.yml": 1398,
	"./teams/edit/da.yml": 1399,
	"./teams/edit/en.yml": 1400,
	"./teams/selector/choose_team/da.yml": 1401,
	"./teams/selector/choose_team/en.yml": 1402,
	"./teams/show/da.yml": 1403,
	"./teams/show/en.yml": 1404,
	"./tenants/select/da.yml": 1405,
	"./tenants/select/en.yml": 1406,
	"./tenants/setup/da.yml": 1407,
	"./tenants/setup/en.yml": 1408,
	"./uni_logins/new/da.yml": 1409,
	"./uni_logins/new/en.yml": 1410,
	"./uni_logins/successful/da.yml": 1411,
	"./uni_logins/successful/en.yml": 1412,
	"./upload_button/index/da.yml": 1413,
	"./upload_button/index/en.yml": 1414,
	"./upload_button_with_preview/index/da.yml": 1415,
	"./upload_button_with_preview/index/en.yml": 1416,
	"./user_steps/edit/da.yml": 1417,
	"./user_steps/edit/en.yml": 1418,
	"./user_steps/element_types/question_dropdown/da.yml": 1419,
	"./user_steps/element_types/question_dropdown/en.yml": 1420,
	"./user_steps/element_types/question_file/index/da.yml": 1421,
	"./user_steps/element_types/question_file/index/en.yml": 1422,
	"./users/confirmation/da.yml": 1423,
	"./users/confirmation/en.yml": 1424,
	"./users/confirmation/index/da.yml": 1425,
	"./users/confirmation/index/en.yml": 1426,
	"./users/confirmation/new/da.yml": 1427,
	"./users/confirmation/new/en.yml": 1428,
	"./users/confirmations/new/da.yml": 1429,
	"./users/confirmations/new/en.yml": 1430,
	"./users/consent/index/da.yml": 1431,
	"./users/consent/index/en.yml": 1432,
	"./users/edit/form/da.yml": 1433,
	"./users/edit/form/en.yml": 1434,
	"./users/edit/form/index/da.yml": 1435,
	"./users/edit/form/index/en.yml": 1436,
	"./users/edit/form/relatives/da.yml": 1437,
	"./users/edit/form/relatives/en.yml": 1438,
	"./users/edit/form/two_factor_authentication/da.yml": 1439,
	"./users/edit/form/two_factor_authentication/en.yml": 1440,
	"./users/edit/school/da.yml": 1441,
	"./users/edit/school/en.yml": 1442,
	"./users/notifications/partial/da.yml": 1443,
	"./users/notifications/partial/en.yml": 1444,
	"./users/passwords/edit/da.yml": 1445,
	"./users/passwords/edit/en.yml": 1446,
	"./users/passwords/edit/index/da.yml": 1447,
	"./users/passwords/edit/index/en.yml": 1448,
	"./users/passwords/new/da.yml": 1449,
	"./users/passwords/new/en.yml": 1450,
	"./users/settings/da.yml": 1451,
	"./users/settings/en.yml": 1452
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 380;